import script from "./Manage.vue?vue&type=script&setup=true&lang=ts"
export * from "./Manage.vue?vue&type=script&setup=true&lang=ts"

import "./Manage.vue?vue&type=style&index=0&id=30e8175b&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30e8175b"]])

export default __exports__